import React, { Children, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import pathRouts from "../../../../shared/enums/pathRoute";
import { menuModeDataAttr, menuModes } from "../../../enums/menuModes";
import logo from "../../../../assests/logo.png";
import classes from "./MobileExpandableMenu.module.css";

export default function MobileExpandableMenu({ children }) {

    const location = useLocation();
    const isHomePage = location.pathname.endsWith(`/${pathRouts.HOME}`) || location.pathname.endsWith(pathRouts.HOME);
    const [menu, setMenu] = useState({ mode: menuModes.CLOSED, items: [] });
    const menuRef = useRef(null);

    useEffect(() => {
        const allItems = Children.toArray(children);
        if (isHomePage)
            setMenu({ mode: menuModes.HALF_OPEN, items: allItems.slice(0, 3) });
        else
            setMenu({ mode: menuModes.CLOSED, items: [] });
    }, [location.pathname, isHomePage, children]);

    useEffect(() => {
        if (menu.mode !== menuModes.FULL_OPEN) return;

        const handleClickOutside = (e) => {
            if (menuRef.current?.contains(e.target)) return;

            setMenu(prev => {
                if (prev.mode !== menuModes.FULL_OPEN) return prev;
                const allItems = Children.toArray(children);
                return isHomePage
                    ? { mode: menuModes.HALF_OPEN, items: allItems.slice(0, 3) }
                    : { mode: menuModes.CLOSED, items: [] };
            });
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [menu.mode, isHomePage, children]);

    const toggle = () => {
        setMenu(prev => {
            const allItems = Children.toArray(children);
            if (isHomePage) {
                return prev.mode === menuModes.FULL_OPEN
                    ? { mode: menuModes.HALF_OPEN, items: allItems.slice(0, 3) }
                    : { mode: menuModes.FULL_OPEN, items: allItems };
            }
            return prev.mode === menuModes.FULL_OPEN
                ? { mode: menuModes.CLOSED, items: [] }
                : { mode: menuModes.FULL_OPEN, items: allItems };
        });
    };

    return (
        <nav ref={menuRef} className={`${classes.Menu} ${classes[menu.mode]}`} data-menu-state={menuModeDataAttr[menu.mode]}>
            <button className={classes.ToggleButton} aria-label="Toggle menu" onClick={toggle} aria-expanded={menu.mode !== menuModes.CLOSED}>
                <img src={logo} alt="" className={classes.ToggleLogo} />
            </button>
            <div className={classes.Panel}>
                <div className={classes.ItemsWrap}>
                    {menu.items}
                </div>
            </div>
        </nav>
    );
}
